import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { StateApiData } from '../models/State.model';
import { StateRepository } from '../repositories/state.repository';

export type GetStatesUseCaseInput = {
    countryCode: string | null;
    language: string;
};

export class GetStatesUseCase
    implements UseCase<GetStatesUseCaseInput, StateApiData>
{
    constructor(private readonly repository: StateRepository) {}

    execute({
        countryCode,
        language,
    }: GetStatesUseCaseInput): Observable<StateApiData> {
        return this.repository.getStates(countryCode, language);
    }
}
